import { Conexion } from "../../../Config/Coneccion";
import conNotasCD from "../../Notas/Conexion";

class CompraConexion extends Conexion {
    clase = 'Compra';
    persistencia = 1000;
    commadUpdate() {
        this.updater(this.clase)
        this.updater('Producto')
    }
    facturar(codigo: string | number, data: any, setData?: (d: any) => void) {
        this.post("/api/Compra/facturar/" + codigo, data, data => { if (setData) setData(data) })
    }
}
var conCo: CompraConexion;
export function conCompra() {
    if (conCo === undefined) conCo = new CompraConexion();
    return conCo;
}
export function conNotasCC(){
    return conNotasCD('Compra/credito');
}
export function conNotasDC(){
    return conNotasCD('Compra/debito');
}